import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  AffirmativeSemantic_getInstance2svzxainpava5 as AffirmativeSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  ID2ebczrc12h07k as ID,
  User3mqs8plvl8nwo as User,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_active2j9ehubxjx5nv as get_active,
  get__id1hi7gtah39onn as get__id,
  get__id1301miildb0kq as get__id_0,
  get__id2p9nbcwbj0zlw as get__id_1,
  get__id336i6k806byxy as get__id_2,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { confirmationDialoginprr3lfvaqc as confirmationDialog } from '../components/dialogs.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { toast4hp3bb4ymp24 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { Formjae7dnqjclc3 as Form } from '../components/form.mjs';
import { Draft3goc8q7vggbic as Draft } from '../../extensions/Draft.ext.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Employer27b20p5x27kte as Employer,
  CareProvider2qcawrqluyllr as CareProvider,
  CareLocation1v3u5wduz023s as CareLocation,
  Family2k7vz7ddyergb as Family,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
  iconButton2nzpucy7a6ixd as iconButton,
  reactiveLabel206b3aonybuoa as reactiveLabel,
  maybeLabel2ow5e5yzodgn0 as maybeLabel,
} from '../components/view-utilities.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance } from '../../theme/semantics.mjs';
import { LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_edit5ty08lpw30d6 as get_edit } from '../../icons.mjs';
import {
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
  PhoneNumber__toString_impl_7i2x3q2my82bpxyutrq as PhoneNumber__toString_impl_7i2x3q,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import {
  RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance,
  renderToStringprxvmjepz2st as renderToString,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import {
  userForm5nk49durav10 as userForm,
  userPermissionskavzssr0zu9q as userPermissions,
} from './userComponents.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function actionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, UserDetailPage$actionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, UserDetailPage$actionBar$slambda($this));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, UserDetailPage$actionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  element_3.set_action_2ds022_k$(Action('Save user', VOID, VOID, VOID, VOID, VOID, UserDetailPage$actionBar$slambda_0($this, element_3)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function UserDetailPage$user$lambda($this$Draft) {
  return $this$Draft.invoke_r7m7el_k$(get_currentSessionNotNull()).get_users_izsycf_k$();
}
function UserDetailPage$render$slambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).get_users_izsycf_k$().get_6ueaa7_k$(new (ID())(this$0.id_1));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_1 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
    var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$5);
    var tmp_1 = get_active(it);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.user_1;
    var tmp$ret$7 = yield* await_0(this_2, $completion);
    this_1.assign_vtsfu6_k$(tmp_1, !tmp$ret$7.active_1);
    var tmp$ret$1 = this_1.build_1k0s4u_k$();
    yield* tmp.modify_ff53f_k$(tmp$ret$1, $completion);
    return Unit_instance;
  }), 0);
}
function UserDetailPage$render$slambda($$this$button, this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    var tmp_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.user_1;
    if ((yield* await_0(this_0, $completion)).active_1) {
      tmp_0 = 'Deactivate user';
    } else {
      tmp_0 = 'Reactivate user';
    }
    var tmp_1 = tmp_0;
    var tmp_2 = ($this$confirmationDialog) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (TextView())($this$confirmationDialog.get_context_h02k06_k$());
      ensureOutermostElement(element);
      $this$confirmationDialog.willAddChild_hz2iwc_k$(element);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
      element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => 'Are you sure you want to ' + ($this$invoke.invoke_r7m7el_k$(this$0.user_1).active_1 ? 'deactivate' : 'reactivate') + ' this user?');
      element.onStartup_vrxh3i_k$();
      $this$confirmationDialog.addChild_2qpft2_k$(element);
      return Unit_instance;
    };
    var tmp_3;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.user_1;
    if ((yield* await_0(this_1, $completion)).active_1) {
      tmp_3 = 'Deactivate';
    } else {
      tmp_3 = 'Reactivate';
    }
    var tmp_4 = tmp_3;
    var tmp_5;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.user_1;
    if ((yield* await_0(this_2, $completion)).active_1) {
      tmp_5 = DangerSemantic_getInstance();
    } else {
      tmp_5 = ImportantSemantic_getInstance();
    }
    var tmp_6 = tmp_5;
    confirmationDialog(tmp, tmp_1, tmp_2, tmp_4, tmp_6, VOID, VOID, UserDetailPage$render$slambda$slambda(this$0));
    return Unit_instance;
  }), 0);
}
function UserDetailPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_userDetailsSectionTitle_o8ze3l_k$();
}
function UserDetailPage$render$lambda_0($this$iconButton) {
  return $this$iconButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_userEditIconDescription_a205ej_k$();
}
function UserDetailPage$render$lambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.editMode_1.set_revjhg_k$(true, $completion);
    return Unit_instance;
  }), 0);
}
function UserDetailPage$render$lambda_1($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_userEmailLabel_3oltlg_k$();
}
function UserDetailPage$render$lambda_2($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_userPhoneLabel_fdgx22_k$();
}
function UserDetailPage$render$lambda_3($this$reactiveLabel) {
  return 'Status';
}
function UserDetailPage$render$lambda_4($this$reactiveLabel) {
  return 'Created';
}
function UserDetailPage$render$lambda_5($this$reactiveLabel) {
  return 'Last updated';
}
function UserDetailPage$render$lambda_6($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function UserDetailPage$actionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function UserDetailPage$actionBar$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.user_1.cancel_2l89ey_k$();
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    return Unit_instance;
  }), 0);
}
function UserDetailPage$actionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudSaveButton_lsaoza_k$();
}
function UserDetailPage$actionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.user_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* this$0.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      this$0.formIssuesDialog$default_8ey6bo_k$($$this$button.get_context_h02k06_k$());
      return Unit_instance;
    }
    yield* this$0.user_1.publish_xq9q2e_k$($completion);
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    var tmp_0 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp$ret$2 = yield* await_1(this_1, $completion);
    toast(tmp_0, tmp$ret$2.get_crudSavedToast_xnj03d_k$());
    return Unit_instance;
  }), 1);
}
var UserDetailPageClass;
function UserDetailPage() {
  if (UserDetailPageClass === VOID) {
    class $ extends Form() {
      constructor(id) {
        super();
        this.id_1 = id;
        var tmp = this;
        tmp.user_1 = validated(Draft(new (ID())(this.id_1), UserDetailPage$user$lambda));
        var tmp_0 = this;
        tmp_0.employers_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
          var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$3);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
          var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$7);
          var tmp$ret$4 = xDataClassPathInsideSet(get__id(it), $this$remember.invoke_r7m7el_k$(this.user_1).managesEmployers_1);
          var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
        });
        var tmp_1 = this;
        tmp_1.providers_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
          var tmp$ret$13 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$13);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
          var tmp$ret$17 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$17);
          var tmp$ret$14 = xDataClassPathInsideSet(get__id_0(it), $this$remember.invoke_r7m7el_k$(this.user_1).managesProviders_1);
          var tmp$ret$10 = new (Query())(tmp$ret$14, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$10));
        });
        var tmp_2 = this;
        tmp_2.locations_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
          var tmp$ret$23 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$23);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
          var tmp$ret$27 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$27);
          var tmp$ret$24 = xDataClassPathInsideSet(get__id_1(it), $this$remember.invoke_r7m7el_k$(this.user_1).managesLocations_1);
          var tmp$ret$20 = new (Query())(tmp$ret$24, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$20));
        });
        var tmp_3 = this;
        tmp_3.families_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_families_is4v1x_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
          var tmp$ret$33 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$33);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
          var tmp$ret$37 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$37);
          var tmp$ret$34 = xDataClassPathInsideSet(get__id_2(it), $this$remember.invoke_r7m7el_k$(this.user_1).managesFamilies_1);
          var tmp$ret$30 = new (Query())(tmp$ret$34, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$30));
        });
        this.editMode_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.user_1).name_1);
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.user_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_4 = get_centered(element_1);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (TextView())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_2);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_2));
        element_2.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.user_1).name_1);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        var tmp_2 = get_centered(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_5 = dynamicThemed(tmp_2, ($this$dynamicThemed) => ChipSemantic_getInstance().plus_duvq05_k$($this$dynamicThemed.invoke_r7m7el_k$(this.user_1).active_1 ? AffirmativeSemantic_getInstance() : DangerSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (TextView())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_5.willAddChild_hz2iwc_k$(element_3);
        var tmp_3 = KMutableProperty0();
        var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_3);
        var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_3));
        element_3.invoke_bnq13k_k$(tmp_5, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.user_1).active_1 ? 'Active' : 'Inactive');
        element_3.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_3);
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_6 = themed(element_0, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Button())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_6.willAddChild_hz2iwc_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_7 = themed(element_4, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (RowOrCol())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_7.willAddChild_hz2iwc_k$(element_5);
        element_5.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        var this_8 = get_centered(element_5);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (IconView())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_8.willAddChild_hz2iwc_k$(element_6);
        var tmp_6 = KMutableProperty0();
        var tmp_7 = IconView$_get_description_$ref_x7iif6(element_6);
        var tmp_8 = getPropertyCallableRef('description', 0, tmp_6, tmp_7, IconView$_set_description_$ref_rpvc1e(element_6));
        element_6.invoke_bnq13k_k$(tmp_8, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.user_1).active_1 ? 'Deactivate user' : 'Reactivate user');
        element_6.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_9 = get_centered(element_5);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (TextView())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        this_9.willAddChild_hz2iwc_k$(element_7);
        var tmp_9 = KMutableProperty0();
        var tmp_10 = TextView$_get_content_$ref_4pzcwl(element_7);
        var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb(element_7));
        element_7.invoke_bnq13k_k$(tmp_11, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.user_1).active_1 ? 'Deactivate user' : 'Reactivate user');
        element_7.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_7);
        element_5.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_5);
        onClick(element_4, VOID, VOID, VOID, UserDetailPage$render$slambda(element_4, this));
        element_4.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_4);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_10 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (RowOrCol())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_10.willAddChild_hz2iwc_k$(element_8);
        element_8.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_11 = themed(element_8, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (RowOrCol())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        this_11.willAddChild_hz2iwc_k$(element_9);
        element_9.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowOrCol())(element_9.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        element_9.willAddChild_hz2iwc_k$(element_10);
        element_10.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_12 = get_centered(element_10);
        var tmp$ret$50 = weight(this_12, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_13 = get_bold(tmp$ret$50);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (TextView())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        this_13.willAddChild_hz2iwc_k$(element_11);
        element_11.set_themeChoice_py59um_k$(element_11.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
        var tmp_12 = KMutableProperty0();
        var tmp_13 = TextView$_get_content_$ref_4pzcwl(element_11);
        var tmp_14 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb(element_11));
        element_11.invoke_bnq13k_k$(tmp_14, UserDetailPage$render$lambda);
        element_11.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_11);
        var tmp_15 = get_centered(element_10);
        var tmp_16 = get_edit(Companion_getInstance_0());
        var tmp_17 = UserDetailPage$render$lambda_0;
        iconButton(tmp_15, tmp_16, tmp_17, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, UserDetailPage$render$lambda$slambda(this));
          return Unit_instance;
        });
        element_10.onStartup_vrxh3i_k$();
        element_9.addChild_2qpft2_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (RowOrCol())(element_9.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        element_9.willAddChild_hz2iwc_k$(element_12);
        element_12.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_14 = weight(element_12, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (RowOrCol())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_14.willAddChild_hz2iwc_k$(element_13);
        element_13.set_vertical_nuap32_k$(true);
        var tmp_18 = UserDetailPage$render$lambda_1;
        reactiveLabel(element_13, tmp_18, ($this$reactiveLabel) => EmailAddress__toString_impl_artjh3($this$reactiveLabel.invoke_r7m7el_k$(this.user_1).email_1));
        var tmp_19 = UserDetailPage$render$lambda_2;
        maybeLabel(element_13, tmp_19, ($this$maybeLabel) => {
          var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(this.user_1).phone_1;
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (PhoneNumber())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = PhoneNumber__toString_impl_7i2x3q(tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs = tmp;
          return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        });
        var tmp_20 = UserDetailPage$render$lambda_3;
        reactiveLabel(element_13, tmp_20, ($this$reactiveLabel) => $this$reactiveLabel.invoke_r7m7el_k$(this.user_1).active_1 ? 'Active' : 'Inactive');
        element_13.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (Separator())(element_12.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        element_12.willAddChild_hz2iwc_k$(element_14);
        element_14.onStartup_vrxh3i_k$();
        element_12.addChild_2qpft2_k$(element_14);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_15 = weight(element_12, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (RowOrCol())(this_15.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        this_15.willAddChild_hz2iwc_k$(element_15);
        element_15.set_vertical_nuap32_k$(true);
        var tmp_21 = UserDetailPage$render$lambda_4;
        reactiveLabel(element_15, tmp_21, ($this$reactiveLabel) => renderToString($this$reactiveLabel.invoke_r7m7el_k$(this.user_1).createdAt_1, RenderSize_Abbreviation_getInstance()));
        var tmp_22 = UserDetailPage$render$lambda_5;
        reactiveLabel(element_15, tmp_22, ($this$reactiveLabel) => renderToString($this$reactiveLabel.invoke_r7m7el_k$(this.user_1).updatedAt_1, RenderSize_Abbreviation_getInstance()));
        element_15.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_15);
        element_12.onStartup_vrxh3i_k$();
        element_9.addChild_2qpft2_k$(element_12);
        element_9.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_9);
        element_8.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_16 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (RowOrCol())(this_16.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        this_16.willAddChild_hz2iwc_k$(element_16);
        element_16.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (Separator())(element_16.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        element_16.willAddChild_hz2iwc_k$(element_17);
        element_17.onStartup_vrxh3i_k$();
        element_16.addChild_2qpft2_k$(element_17);
        actionBar(this, element_16);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp$ret$80 = themed(element_16, CardSemantic_getInstance());
        userForm(this, tmp$ret$80, this.user_1, false);
        element_16.onStartup_vrxh3i_k$();
        this_16.addChild_2qpft2_k$(element_16);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp$ret$81 = themed(element, CardSemantic_getInstance());
        userPermissions(tmp$ret$81, this.editMode_1, this.user_1, this.employers_1, this.providers_1, this.locations_1, this.families_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_17 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (RowOrCol())(this_17.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        this_17.willAddChild_hz2iwc_k$(element_18);
        element_18.set_vertical_nuap32_k$(true);
        actionBar(this, element_18);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (Separator())(element_18.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        element_18.willAddChild_hz2iwc_k$(element_19);
        element_19.onStartup_vrxh3i_k$();
        element_18.addChild_2qpft2_k$(element_19);
        element_18.onStartup_vrxh3i_k$();
        this_17.addChild_2qpft2_k$(element_18);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_18 = shownWhen(element, VOID, VOID, UserDetailPage$render$lambda_6);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (Space())(this_18.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_20);
        this_18.willAddChild_hz2iwc_k$(element_20);
        element_20.onStartup_vrxh3i_k$();
        this_18.addChild_2qpft2_k$(element_20);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'UserDetailPage', VOID, VOID, [Page(), CanBlockBack()]);
    UserDetailPageClass = $;
  }
  return UserDetailPageClass;
}
//region block: exports
export {
  UserDetailPage as UserDetailPage3cz18tdewf15f,
};
//endregion

//# sourceMappingURL=UserDetailPage.mjs.map
